define('viewModels/widgets/audio/VolumeControlView',[
    'lib/knockout',
    'lib/lodash4',
    'lib/bluebird',
    'services/loggingService',
    'services/userService',
    'services/userSettingsService',
    'viewModels/ViewModel'
], function (ko,
             _,
             Promise,
             loggingService,
             userService,
             userSettingsService,
             ViewModel) {
    'use strict';

    //
    //Constants
    //

    var VOLUME_INCREMENT     = 20;
    var DEFAULT_VOLUME_LEVEL = 80;
    var SETTINGS_NAMESPACE   = "AudioSettings";

    var volumeLevel = ko.observable(null);
    ko.computed(function () {
        // Clear the cached level if the user changes
        ko.unwrap(userService.currentUser);
        volumeLevel(null);
    });

    // All volume controls share a common volume level, and it gets
    // persisted to userSettingsService.
    var userVolumeSettingService =  {
        getVolume: function () {
            if (userService.currentUser()) {
                var unwrapped = ko.unwrap(volumeLevel);
                if (unwrapped) {
                    return Promise.resolve(unwrapped);
                } else {
                    return userSettingsService.getSettings(SETTINGS_NAMESPACE)
                        .then(function (settings) {
                            var volumeFromSettings = settings[SETTINGS_NAMESPACE].volume;
                            volumeLevel(volumeFromSettings || DEFAULT_VOLUME_LEVEL);
                            return volumeLevel();
                        })
                        .catch(function (error) {
                            loggingService.warn("There was an error getting user settings for volume:" +error);
                            return DEFAULT_VOLUME_LEVEL;
                        });
                }
            } else {
                return Promise.resolve(DEFAULT_VOLUME_LEVEL);
            }
        },
        setVolume: function (newValue) {
            volumeLevel(newValue);

            var newSettings = {};
            newSettings[SETTINGS_NAMESPACE] = {
                'volume': newValue
            };

            return userSettingsService.setSettings(newSettings)
                .catch(function (e) {
                    loggingService.warn("Failed to set the user's volume setting", e);
                });
        }
    };

    var VolumeControlView = ViewModel.extend(function (options) {
        var self = this;
        self.volumePopOverOpen  = ko.observable(false);

        options = _.assign({
            // volumeControls with 'syncVolumeToUserSettings = true' all share the same volumeLevel
            // and persist changes to userSettingsService.
            // volumeControls with 'syncVolumeToUserSettings = false' will use userSettingsService
            // to provide the default volume level only.
            syncVolumeToUserSettings: true
        }, options);

        if (options && options.syncVolumeToUserSettings) {
            self.volumeLevel = ko.computed({
                write: function (newValue) {
                    volumeLevel(newValue);
                    return newValue;
                },
                read: function () {
                    var unwrapped = volumeLevel();
                    if (null === unwrapped) {
                        return DEFAULT_VOLUME_LEVEL;
                    }
                    return unwrapped;
                }
            });
        } else {
            self.volumeLevel = ko.observable(DEFAULT_VOLUME_LEVEL);
        }

        self.updateVolume = function (percentPosition, event) {
            if (event) {
                event.preventDefault();
            }
            self.setVolumeLevel(percentPosition*100);
        };

        // An internal function for setting volume. This will not attempt
        // to update the volume level in userSettingsService.
        var setVolumeLevel = function (newValue) {
            if (newValue < 0){
                newValue = 0;
            } else if (newValue > 100){
                newValue = 100;
            }

            self.volumeLevel(newValue);
            return newValue;
        };

        /**
         * Sets the volume level from user settings
         */
        self.setDefaultVolume = function () {
            return userVolumeSettingService.getVolume()
                .then(function(volume){
                    return setVolumeLevel(volume);
                })
                .catch(function(e){
                    loggingService.warn("Error updating the volume level "+e );
                    return DEFAULT_VOLUME_LEVEL;
                });
        };

        /**
         * Sets the volume level in the UI and also in the user settings.
         * @param volumeLevel
         */
        self.setVolumeLevel = function(newValue) {
            var temp = setVolumeLevel(newValue);
            if (options.syncVolumeToUserSettings) {
                userVolumeSettingService.setVolume(temp);
            }
        };

        self.increaseVolume = function () {
            var newLevel = self.volumeLevel() + VOLUME_INCREMENT;
            self.setVolumeLevel(newLevel);
        };

        self.decreaseVolume = function () {
            var newLevel = self.volumeLevel() - VOLUME_INCREMENT;
            self.setVolumeLevel(newLevel);
        };

        self.isMuted = self.computed(function(){
            return self.volumeLevel() <= 0;
        });
    });

    return VolumeControlView;
});

